import React, { useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, HStack, Input, Select, Textarea,
  FormControl, FormLabel, Text, useToast,
} from '@chakra-ui/react';
import api from '../api';

export default function HoldModal({ taskId, isHeld, isOpen, onClose, onRefresh }) {
  const [holdForm, setHoldForm] = useState({ hold_reason: 'waiting_on_client', explanation: '', expected_end_date: '' });
  const [resolveReason, setResolveReason] = useState('');
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  const handleHold = async () => {
    if (!holdForm.hold_reason) return;
    setSaving(true);
    try {
      await api.put(`/tasks/${taskId}/hold`, holdForm);
      toast({ title: 'Task placed on hold', status: 'info', duration: 1500 });
      onRefresh();
      onClose();
    } catch(e) { toast({ title: 'Failed', status: 'error', duration: 2000 }); }
    finally { setSaving(false); }
  };

  const handleUnhold = async () => {
    setSaving(true);
    try {
      await api.put(`/tasks/${taskId}/unhold`, { resolved_reason: resolveReason || 'Resolved' });
      toast({ title: 'Hold resolved', status: 'success', duration: 1500 });
      onRefresh();
      onClose();
    } catch(e) { toast({ title: 'Failed', status: 'error', duration: 2000 }); }
    finally { setSaving(false); }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="md">{isHeld ? 'Resolve Hold' : 'Place on Hold'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {!isHeld ? (
            <VStack spacing={3}>
              <FormControl>
                <FormLabel fontSize="xs" mb={0.5}>Reason</FormLabel>
                <Select size="sm" value={holdForm.hold_reason}
                  onChange={e => setHoldForm(p => ({ ...p, hold_reason: e.target.value }))}>
                  <option value="waiting_on_client">Waiting on Client</option>
                  <option value="waiting_on_supplier">Waiting on Supplier</option>
                  <option value="waiting_on_us">Waiting on Us</option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel fontSize="xs" mb={0.5}>Explanation</FormLabel>
                <Textarea size="sm" rows={2} value={holdForm.explanation}
                  onChange={e => setHoldForm(p => ({ ...p, explanation: e.target.value }))}
                  placeholder="Optional details..." />
              </FormControl>
              <FormControl>
                <FormLabel fontSize="xs" mb={0.5}>Expected End Date</FormLabel>
                <Input size="sm" type="date" value={holdForm.expected_end_date}
                  onChange={e => setHoldForm(p => ({ ...p, expected_end_date: e.target.value }))} />
                <Text fontSize="9px" color="gray.400">Optional</Text>
              </FormControl>
            </VStack>
          ) : (
            <VStack spacing={3}>
              <Text fontSize="sm">Are you sure you want to resolve this hold?</Text>
              <FormControl>
                <FormLabel fontSize="xs" mb={0.5}>Resolution Reason</FormLabel>
                <Textarea size="sm" rows={2} value={resolveReason}
                  onChange={e => setResolveReason(e.target.value)}
                  placeholder="Why is the hold being resolved?" />
              </FormControl>
            </VStack>
          )}
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="ghost" mr={2} onClick={onClose}>Cancel</Button>
          <Button size="sm" bg="brand.600" color="white" _hover={{ bg: 'brand.700' }}
            onClick={isHeld ? handleUnhold : handleHold} isLoading={saving}>
            {isHeld ? 'Resolve Hold' : 'Place on Hold'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
